//@ts-nocheck

import dropSlider from "./dropSlider";
import provisionsAccordion from "./provisionsAccordion";
import sectionSelectAjax from "./sectionSelectAjax";

const issueAreaSectionAjax = () => {
  const wrapper = document.querySelector(".js-issue-main");
  if (!wrapper) {
    return;
  }
  const page = wrapper.getAttribute("data-page");

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("js-issue-main-labels")) {
      let index = e.target.getAttribute("data-index");
      fetchData(index);
    }
  });

  async function fetchData(index) {
    let formData = new FormData();
    formData.append("action", "issue_areas_ajax");
    formData.append("index", index);
    formData.append("page", page);
    const response = await fetch(window.globals.ajax_url, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.files;
    sectionSelectAjax();
    dropSlider();
    provisionsAccordion();
  }
};

export default issueAreaSectionAjax;
